import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiResponseObject } from '../models/responses/api-response-object';
import { SkillDto } from '../models/SkillDto';
import { SkillRequest } from '../models/requests/skill-request';
@Injectable({
  providedIn: 'root'
})
export class SkillsService {


  constructor(private httpClient: HttpClient) { }
  getSkills(): Observable<ApiResponseObject<SkillDto[]>> {
    return this.httpClient.get<ApiResponseObject<SkillDto[]>>(`${environment.apiUrl}/Skills`);
  }
  
  saveSkill(newSkillRequest: SkillRequest): Observable<ApiResponseObject<SkillDto>> {
   
    return this.httpClient.post<ApiResponseObject<SkillDto>>(`${environment.apiUrl}/Skills`, newSkillRequest);
  }
}
